import React, { useMemo, useState } from "react";
import { TextSkeleton } from "../../interfaccia/loading";

const SITE_LABELS = { VIG: "Viglietti Sport", BOT: "Bottero Ski" };
const SITE_KEYS = ["VIG", "BOT"];

function TextValues({ values, html = false }) {
  if (!values?.length) return <p className="f6 i gray">Non presente</p>;
  return values.map((item) => (
    <div className="mb3" key={`${item.languageId}-${item.value}`}>
      <div className="f7 ttu tracked gray">Italiano</div>
      {html ? <div className="f6" dangerouslySetInnerHTML={{ __html: item.value }} /> : <div className="f6 pre-wrap">{item.value}</div>}
    </div>
  ));
}

export default function TestiOnline({
  data,
  loading,
  error,
  site: controlledSite,
  showSiteTabs = true,
}) {
  const availableSites = useMemo(
    () => SITE_KEYS.filter((site) => data?.sites?.[site]?.available),
    [data],
  );
  const [site, setSite] = useState("VIG");
  let selectedSite = availableSites.includes(site) ? site : availableSites[0];
  if (controlledSite) {
    selectedSite = availableSites.includes(controlledSite)
      ? controlledSite
      : null;
  }
  if (loading) return <div className="pa3"><TextSkeleton lines={8} tone="soft" /></div>;
  if (error) return <div className="pa3 f6 red">{error}</div>;
  const texts = selectedSite ? data?.sites?.[selectedSite]?.texts : null;
  return (
    <div className="pa2">
      {showSiteTabs && <div className="mb3">
        {SITE_KEYS.map((item) => {
          const siteData = data?.sites?.[item];
          const isAvailable = Boolean(siteData?.available);
          const unavailableMessage = siteData?.unavailableMessage || "Dati online non disponibili.";
          return (
            <span key={item} className="dib mr2" title={isAvailable ? "" : unavailableMessage}>
            <button
              type="button"
              disabled={!isAvailable}
              title={isAvailable ? "" : unavailableMessage}
              onClick={() => setSite(item)}
              className={isAvailable ? (item === selectedSite ? "tastoColore" : "tastoBianco") : "tastoRosso white o-60"}
            >
              {SITE_LABELS[item]}
            </button>
            </span>
          );
        })}
      </div>}
      {!selectedSite && <p className="f6 i gray">Nessun sito è al momento interrogabile per questo articolo.</p>}
      {selectedSite && <>
        <h4 className="mt0 mb2">Nome prodotto</h4><TextValues values={texts?.name} />
        <h4 className="mt3 mb2">Descrizione breve</h4><TextValues values={texts?.descriptionShort} html />
        <h4 className="mt3 mb2">Descrizione lunga</h4><TextValues values={texts?.descriptionLong} html />
      </>}
    </div>
  );
}
